<template>
  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item">
          <a href="/home" class="nav-link" :class="{ 'active': $page.url === '/home' || $page.url === '/profile' }">
            <i class="nav-icon fas fa-tachometer-alt"></i>
            <p>
              Dashboard
            </p>
          </a>
        </li>
        <li class="nav-item" v-if="hasPermission(['team']) || hasRole(['Super Admin'])">
          <a href="/team" class="nav-link" :class="{ active: $page.url.startsWith('/team') }">
            <i class="fas fa-users nav-icon"></i>
            <p>Team</p>
          </a>
        </li>
        <li class="nav-item" v-if="hasPermission(['kunjungan']) || hasRole(['Super Admin'])">
          <a href="/kunjungan" class="nav-link" :class="{ active: $page.url.startsWith('/kunjungan') }">
            <i class="nav-icon fas fa-biking"></i>
            <p>Kunjungan</p>
          </a>
        </li>
        <li class="nav-item" v-if="hasPermission(['tagihan']) || hasRole(['Super Admin'])">
          <a href="/tagihan" class="nav-link" :class="{ active: $page.url.startsWith('/tagihan') }">
            <i class="nav-icon fas fa-address-book"></i>
            <p>Tagihan</p>
          </a>
        </li>
        <li class="nav-item"
          v-if="hasPermission(['reminder']) || hasRole(['Super Admin']) && $page.props.tenant === 'kedungwaru'">
          <a href="/reminder" class="nav-link" :class="{ active: $page.url.startsWith('/reminder') }">
            <i class="nav-icon far fa-clock"></i>
            <p>Pengingat SP</p>
          </a>
        </li>
        <li class="nav-item" v-if="hasPermission(['adminlog']) || hasRole(['Super Admin'])">
          <a href="/adminlog" class="nav-link" :class="{ 'active': $page.url.startsWith('/adminlog') }">
            <i class="nav-icon fa fa-wave-square"></i>
            <p>
              Activity Log
            </p>
          </a>
        </li>
        <li class="nav-item" v-else-if="hasPermission(['clientlog'])">
          <a href="/clientlog" class="nav-link" :class="{ 'active': $page.url.startsWith('/clientlog') }">
            <i class="nav-icon fa fa-wave-square"></i>
            <p>
              Activity Log
            </p>
          </a>
        </li>
        <li class="nav-header" v-if="hasPermission(['posisi', 'pemakai']) || hasRole(['Super Admin'])">SETTING</li>
        <li class="nav-item" :class="{ 'menu-open': $page.url.startsWith('/role') || $page.url.startsWith('/user') }"
          v-if="hasPermission(['posisi', 'pemakai']) || hasRole(['Super Admin'])">
          <a href="#" class="nav-link"
            :class="{ 'active': $page.url.startsWith('/role') || $page.url.startsWith('/user') }">
            <i class="nav-icon fas fa-user-shield"></i>
            <p>
              Hak Akses
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" v-if="hasPermission(['posisi']) || hasRole(['Super Admin'])">
              <a href="/role" class="nav-link" :class="{ 'active': $page.url.startsWith('/role') }">
                <i class="far fa-circle nav-icon"></i>
                <p>Posisi</p>
              </a>
            </li>
            <li class="nav-item" v-if="hasPermission(['pemakai']) || hasRole(['Super Admin'])">
              <a href="/user" class="nav-link" :class="{ 'active': $page.url.startsWith('/user') }">
                <i class="far fa-circle nav-icon"></i>
                <p>Pemakai</p>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
</script>
